<template>
  <div class="w-full flex">
    <div class="w-5/6 flex">
      <day-selector
        v-model="selectedDays"
        :options="weekDays"
        :searchable="false"
        class="w-1/3 mt-2 mr-2 -ml-2 relative"
        track-by="id"
        label-key="name"
        @select="scheduleUpdate"
        @remove="scheduleUpdate"
        @select-all="scheduleUpdate"
      />
      <pt-form-group
        class="text-base w-1/3 mr-2 whitespace-normal"
      >
        <pt-timepicker
          id="start_time"
          v-model="start_time"
          :hide-clear-button="true"
          :class="overlappedClass"
          placeholder="Enter Time Here"
          @input="scheduleUpdate"
        />
      </pt-form-group>
      <pt-form-group
        class="text-base w-1/3 mr-2 whitespace-normal"
      >
        <pt-timepicker
          id="end_time"
          v-model="end_time"
          :hide-clear-button="true"
          :class= "overlappedClass"
          placeholder="Enter Time Here"
          @input="scheduleUpdate"
        />
      </pt-form-group>
    </div>
    <div class="w-1/6 pl-4 flex justify-center">
      <pt-button
        :disabled="isDeleteDisabled"
        rounded="circular"
        class="mt-2"
        variant="danger-outline"
        @action="deleteRow"
      >
        <i class="fa fa-times" aria-hidden="true" />
      </pt-button>
    </div>
  </div>
</template>

<script>
import { PtFormGroup, PtFormInput, PtFormCheckbox } from '@pathao/ui-components/esm/FormComponents';
import { PtTimepicker } from '@pathao/ui-components/esm/Timepicker';
import DaySelector from '@components/common/DaySelector/index.vue';
import { WEEK_DAYS } from '@src/constants';
import setTime from '@utils/set-time';
import getTime from '@utils/get-time';

export default {
  name: 'ScheduleRow',
  components: {
    PtFormGroup,
    PtFormInput,
    PtTimepicker,
    PtFormCheckbox,
    DaySelector,
  },
  props: {
    scheduleDetails: {
      type: Object,
      required: true,
    },
    scheduleLength: {
      type: Number,
      required: true,
    },
    overlappedDays: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      index: 1,
      id: null,
      start_time: null,
      end_time: null,
      selectedDays: [],
      weekDays: WEEK_DAYS,
      isTimeOverlapped: false,
    };
  },
  computed: {
    isDeleteDisabled() {
      return this.scheduleLength < 2;
    },
    overlappedClass() {
      return this.isTimeOverlapped ? 'overlapped-timepicker' : '';
    },
  },
  watch: {
    scheduleDetails: {
      handler(newVal, oldVal) {
        if (newVal.id) {
          this.id = newVal.id;
          this.start_time = setTime(new Date(), newVal.opening_time);
          this.end_time = setTime(new Date(), newVal.closing_time);
          this.selectedDays = newVal.days.map((day, index) => ({
            id: WEEK_DAYS.find(weekDay => weekDay.name === day).id, name: day,
          }));
        }
      },
      deep: true,
      immediate: true,
    },
    overlappedDays: {
      handler(newVal, oldVal) {
        // Compare the new array with the old array
        if (newVal.length !== oldVal.length || !newVal.every((item, index) => item === oldVal[index])) {
          this.isTimeOverlapped = this.isOverlapped();
        }
      },
      deep: true,
    },
  },
  methods: {
    getUpdatedSchedule(type = 'update') {
      const schedule = {
        id: type === 'duplicate' ? `${this.id}-${this.index - 1}` : this.id,
        opening_time: getTime(this.start_time),
        closing_time: getTime(this.end_time),
        days: this.selectedDays.map(day => day.name),
      };
      if (type === 'duplicate') {
        this.index++;
      }
      return schedule;
    },
    scheduleUpdate() {
      this.isTimeOverlapped = false;
      this.$emit('emptyOverlappedDays');
      this.$emit('updateSchedules', this.getUpdatedSchedule());
    },
    deleteRow() {
      this.$emit('deleteRow', this.scheduleDetails.id);
    },
    containsDay(overlappedDay) {
      return this.selectedDays.some((day) => {
        return day.name === overlappedDay;
      });
    },
    isOverlapped() {
      return this.overlappedDays.some((schedule) => {
        return schedule.closing_time === getTime(this.end_time) &&
           schedule.opening_time === getTime(this.start_time) &&
           this.containsDay(schedule.day);
      });
    },
  },
};
</script>

<style>
  .pt-allselect-container .pt-allselect-options-list {
    max-height: 320px;
    overflow-y: scroll;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    border-top-width: 0;
    position: absolute;
    z-index: 50;
  }
  .pt-timepicker input {
    height: 40px;
  }
  .pt-allselect-container .pt-allselect-options-list .pt-list-item {
    cursor: pointer;
  }
</style>

<style>
  .pt-form-group .pt-timepicker {
    margin-top: 8px
  }
  .overlapped-timepicker > input {
    border-color: crimson;
  }
</style>
